import { useMutation } from "@tanstack/react-query"
import {createAxiosWithAuth} from './middleware'

export const useSetAreaConfigItem = () =>{   
  const axios = createAxiosWithAuth();

   return useMutation({
      mutationFn: async (query) => {
        return await axios.post('/ecology/area/set', query)
      },
    })
}